import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient, apiErrorMessage } from "../api/client";
import type { SignedIn } from "../lib/auth";
import { Spinner } from "../components/Spinner";

/* Where the app opens. A person who owns a campaign that is not finished
 * lands on My campaigns, and everyone else on Campaigns, as before (James,
 * 2026-10-09). Who owns what is the engine's answer, from api.my_campaign.
 * If the answer does not load, the app opens on Campaigns, which works for
 * everyone, and the reason goes to the console.
 * docs/plans/campaign-assignment.md, milestone 10. */
export function Home({ session }: { session: SignedIn }) {
  const q = useQuery({
    queryKey: ["my-campaigns", "any-open"],
    queryFn: async () => {
      const { error, count } = await apiClient(session.idToken).from("my_campaign")
        .select("id", { count: "exact", head: true })
        .in("stage", ["draft", "enriching", "ready_to_call", "calling"]);
      if (error) throw new Error(apiErrorMessage(error));
      return count ?? 0;
    },
  });
  useEffect(() => {
    if (q.isError) console.error("Opening on Campaigns, because My campaigns did not answer:", q.error);
  }, [q.isError, q.error]);

  if (q.isLoading) return <main><p className="muted"><Spinner />Opening your campaigns.</p></main>;
  return <Navigate to={!q.isError && (q.data ?? 0) > 0 ? "/my-campaigns" : "/campaigns"} replace />;
}
